import React from 'react';
import PropTypes from 'prop-types';
import StatefulSubmitButton from 'views/StatefulSubmitButton';
import Icon from 'views/Icon';
import classnames from 'classnames';
import {
  triggerEvent,
  scrollTop,
} from 'config/utils';

const AddToCartButton = ({ isBeingCarted, isCarted, onClick }) => {
  return (
    <StatefulSubmitButton
      disabled={isBeingCarted}
      className={classnames(
        'flush',
        isCarted ? 'btn-blue' : 'btn-green btn-outline'
      )}
      onClick={e => {
        if (isCarted) {
          e.preventDefault();
          e.stopPropagation();
          scrollTop();
          triggerEvent(
            document.querySelector('.cart--dropdown .dropdown-control'),
            'openDropdown'
          );
          return false;
        }
        onClick(e);
      }}
      >
      { isCarted ?
        <span>
          <Icon className="ui-1_check-circle-08" />
          Go to Cart
        </span> :
        <span>
          <Icon className="shopping_cart-simple" />
          Add to Cart
        </span>
      }
    </StatefulSubmitButton>

  );
};

export default AddToCartButton;

AddToCartButton.propTypes = {
  isBeingCarted: PropTypes.bool.isRequired,
  isCarted: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/cart/AddToCartButton.js